/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { dropTask } from 'ember-concurrency';
import ApiService from 'cio/services/api';
import ApiErrorsService from 'cio/services/api-errors';
import { inject as service } from '@ember/service';
import AlertsService from 'cio/services/alerts';
import InAppCredentialsService from 'cio/services/in-app-credentials';

const GIST_AUTOPROVISION_ERROR_MESSAGE =
  'Error enabling in-app in your workspace. Please try again or reach out to win@customer.io for troubleshooting.';

interface InAppAutoSetupArgs {
  message: string;
  onInAppEnabled?: () => void;
  onTaskRunning?: (running: boolean) => void;
}

export default class InAppAutoSetup extends Component<InAppAutoSetupArgs> {
  @service api!: ApiService;
  @service apiErrors!: ApiErrorsService;
  @service alerts!: AlertsService;
  @service inAppCredentials!: InAppCredentialsService;

  get buttonMessage() {
    return this.args.message ?? 'Set up in-app messaging';
  }

  provisionAutomatically = dropTask(async () => {
    try {
      this.args.onTaskRunning?.(true);
      await this.api.post('in_app/provision', {
        ignoreErrors: true,
        includeStatus: true,
      });
    } catch (e) {
      if (e.status === '500') {
        // Very unlikely to happen in Production, most probable cause for this error is a Gist API call's timeout.
        this.alerts.error('in_app.auto_provisioning', GIST_AUTOPROVISION_ERROR_MESSAGE);
      } else {
        this.apiErrors.report(e);
      }
      return;
    } finally {
      this.args.onTaskRunning?.(false);
    }

    this.args.onInAppEnabled?.();
  });

  loadIntegrationData = dropTask(async () => {
    let { isIntegrationEnabled } = await this.inAppCredentials.loadCredential.perform();

    if (isIntegrationEnabled) {
      await this.inAppCredentials.loadGistAuthenticationToken.perform();
    }
  });
}
